import styled, { css, createGlobalStyle, keyframes, ThemeProvider } from 'styled-components';

// theme.ts
// your theme variables
export interface IThemeInterface {
  primary: string;
  componentBackground: string;
  componentBackgroundSecondary: string;
}

export const theme = {
  default: {
    primary: '#fff',
    componentBackground: '#fff',
    componentBackgroundSecondary: '#fff',
  },
};

export { css, createGlobalStyle, keyframes, ThemeProvider };
export default styled;
